import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Table } from 'antd';
import Card from "components/card";
import Button from "components/button";
import CrudOption from "components/dropdown/crudoption";
import { PlusOutlined } from '@ant-design/icons';
import { getAnimalInventoryList, doAnimalInventoryDelete } from "../../../../redux/farmanimal/farmAnimalState";
import { handleTableChange, getAnimalTypeRoute } from "../../../../utils/index";

const AnimalInventoryTable = ({ recordList, pagination, doSearch, doDelete, animalTypeId, filters }) => {
  	const columns = [
		{
	        title: `Original Tag ID`,
	        dataIndex: 'original_tag_id',
	        key: 'original_tag_id',
	        width: '12%',
	        sorter: true,
	        render:(original_tag_id) => <span>{original_tag_id}</span>
	    },  
		{
	        title: `Current Tag ID`,
	        dataIndex: 'tag_id',
	        key: 'tag_id',
	        width: '12%',
	        sorter: true,
	        render:(tag_id) => <span>{tag_id}</span>
	    },   
		{
	        title: `Breed`,
	        dataIndex: 'breed',
	        key: 'breed',
	        width: '10%',
	        render:(breed) => <span>{breed?.name}</span>
	    }, 
		{
	        title: `Gender`,
	        dataIndex: 'gender',
	        key: 'gender',
	        width: '10%',
	        render:(gender) => <span>{gender?.name}</span>
	    },
		{
	        title: `Transfered`,
	        dataIndex: 'was_transfered',
	        key: 'was_transfered',
	        width: '8%',
	        render:(was_transfered) => <span>{was_transfered}</span>
	    },
		
		{
	        title: `Current Farm Location`,
	        dataIndex: 'farm',
	        key: 'farm',
	        width: '25%',
	        sorter: true,
	        render:(farm) => <span>{farm?.name}</span>
	    }, 
	    {
	        title: <Button extra="btn-small">
			      		<a href={`/console/animal-inventory/${getAnimalTypeRoute(animalTypeId)}/add`}>
					        <PlusOutlined />{' '}Add
					  	</a>
			    	</Button>,
	        dataIndex: 'id',
	        key: 'id',
	        width: '13%',
	        render:(id, record) => <CrudOption 
				baseRoute={`/console/animal-inventory/${getAnimalTypeRoute(animalTypeId)}`} 
				recordId={id} 
				deleteHandler={doDelete}
				allowEdit={record.was_transfered === 'No'}
				allowDelete={record.was_transfered === 'No'}
				/>
	    },
    ];
	
	useEffect(() => {
	    doSearch({paginate: pagination.per_page, type_id: animalTypeId, inventory: 1});
    }, [doSearch, pagination.per_page]);

  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden mb-3">	      	
	      		<Table
		        	dataSource={recordList}
		        	columns={columns} 
		            rowKey={(record) => record.id}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}
		            onChange={handleTableChange(doSearch, filters)}  
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.farmAnimal.inventoryList?.items,
	pagination: state.farmAnimal.inventoryList?.pagination,
	filters: state.farmAnimal.inventoryList?.filters,
  	requesting: state.farmAnimal.inventoryList?.requesting,
  	error: state.farmAnimal.inventoryList?.error,	  
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getAnimalInventoryList(filters)),
  doDelete: (id) => dispatch(doAnimalInventoryDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AnimalInventoryTable);